import React from 'react';
import { Row } from 'react-bootstrap';
import { buildWhereForDates, FieldDateRanger, FormCol, FormFilterCard } from 'motion-components';
import { useTranslation } from 'react-i18next';
import { FieldSelectCollector, FieldSelectRegion } from 'shared-pages';
import { useRootStore } from 'store';
import { subYears } from 'date-fns';

export function buildWhereFromFilterValues(values): string {
  let where = {};

  if (values) {
    if (values.searchText) {
      const searchText = `%${values.searchText}%`;
      const likeObj = { $like: searchText };
      where = {
        ...where,
        $or: [
          { code: likeObj },
          { '$collectionpoint.name$': likeObj },
          { '$collectionpoint.addressCity$': likeObj },
          { '$collectionpoint.addressArea$': likeObj },
        ],
      };
    }

    if (values.isActive !== undefined && values.isActive !== null && values.isActive !== '') {
      where = { ...where, isActive: values.isActive };
    }

    if (values.startDate || values.endDate) {
      where = {
        ...where,
        ...{
          $or: [
            buildWhereForDates(values.startDate, values.endDate, 'orderedDate'),
            buildWhereForDates(values.startDate, values.endDate, 'firstDate'),
          ],
        },
      };
    }

    if (values.collectorId) {
      where = { ...where, collectorId: values.collectorId };
    }

    if (values.regionId) {
      where = { ...where, regionId: values.regionId };
    }

    if (values.statusId && Array.isArray(values.statusId) && values.statusId.length > 0) {
      where = { ...where, statusId: values.statusId.map((v) => v) };
    }
  }

  return JSON.stringify(where);
}

export type CollectionOrdersStatusesFilterValues = {
  searchText: string;
  collectorId?: number;
  isActive?: boolean;
  regionId?: number;
  startDate?: Date | null;
  endDate?: Date | null;
  statusId?: number[];
};

export function getDefaultLastYearRange() {
  const today = new Date();
  return {
    startDate: subYears(today, 1),
    endDate: today,
  };
}

export const CollectionOrdersStatusesFilters = ({
  initialValues,
  onChange,
  disable = false,
}: {
  initialValues: Partial<CollectionOrdersStatusesFilterValues>;
  onChange: (values: CollectionOrdersStatusesFilterValues) => void;
  disable?: boolean;
}) => {
  const { t } = useTranslation();
  const { appStore } = useRootStore();
  const defaultRange = getDefaultLastYearRange();

  const filters: CollectionOrdersStatusesFilterValues = {
    searchText: initialValues?.searchText ?? '',
    collectorId: initialValues?.collectorId ?? undefined,
    isActive: initialValues?.isActive ?? true,
    regionId: initialValues?.regionId ?? undefined,
    startDate: initialValues?.startDate ?? defaultRange.startDate,
    endDate: initialValues?.endDate ?? defaultRange.endDate,
    statusId: initialValues?.statusId ?? [],
  };

  const handleFiltersSubmit = (values, { setSubmitting }) => {
    if (disable) return;
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 250);
  };

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        <FieldDateRanger as={FormCol} label={t('Υποβολή από')} name="startDate" name2="endDate" />
        {appStore.isPlatformOwner && <FieldSelectCollector as={FormCol} />}
        <FieldSelectRegion as={FormCol} />
      </Row>
    </FormFilterCard>
  );
};
